import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index'
import AdminLogin from '@/pages/admin/AdminLogin'
import Players from '@/pages/admin/players/Players'
import PlayersOnline from '@/pages/admin/players-online/PlayersOnline'
import Player from '@/pages/admin/players/Player'
import NewPlayer from '@/pages/admin/players/NewPlayer'
import NewGroupPlayer from '@/pages/admin/players/NewGroupPlayer'
import Result from '@/pages/admin/players/Result'
import EditPlayer from '@/pages/admin/players/EditPlayer'
import Groups from '@/pages/admin/groups/Groups'
import Group from '@/pages/admin/groups/Group'
import NewGroup from '@/pages/admin/groups/NewGroup'
import EditGroup from '@/pages/admin/groups/EditGroup'
import GroupPlayers from '@/pages/admin/groups/GroupPlayers'
import GroupTests from '@/pages/admin/groups/GroupTests'
import Tests from '@/pages/admin/tests/Tests'
import EditTest from '@/pages/admin/tests/EditTest'

import Start from '@/pages/game/Start'
import FinishGame from '@/pages/game/FinishGame'
import StartTest from '@/pages/game/StartTest'
import TestStart from '@/pages/game/TestStart'
import TestHelp from '@/pages/game/TestHelp'
import AuthService from '@/services/AuthService'
import PlayerLogin from '@/pages/game/PlayerLogin'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    /* admin */
    {
      path: '/',
      name: 'Index',
      component: Index
    },

    /* Работа с участниками */
    {
      path: '/admin',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/admin/players',
      name: 'Players',
      component: Players,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/players/new',
      name: 'NewPlayer',
      component: NewPlayer,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/players/:playerId(\\d+)/results/:resultId(\\d+)',
      name: 'Result',
      component: Result,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/players/edit/:id(\\d+)',
      name: 'EditPlayer',
      component: EditPlayer,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/players/:id(\\d+)',
      name: 'Player',
      component: Player,
      beforeEnter: AuthService.requireAuth
    },

    /* Участники онлайн */
    {
      path: '/admin/players-online',
      name: 'PlayersOnline',
      component: PlayersOnline,
      beforeEnter: AuthService.requireAuth
    },

    /* Работа с группами */
    {
      path: '/admin/groups',
      name: 'Groups',
      component: Groups,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/groups/new',
      name: 'NewGroup',
      component: NewGroup,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/groups/edit/:id(\\d+)',
      name: 'EditGroup',
      component: EditGroup,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/groups/:id(\\d+)',
      name: 'Group',
      component: Group,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/groups/:id/players',
      name: 'GroupPlayers',
      component: GroupPlayers,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/groups/:id/players/new',
      name: 'NewGroupPlayer',
      component: NewGroupPlayer,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/groups/:id/tests',
      name: 'GroupTests',
      component: GroupTests,
      beforeEnter: AuthService.requireAuth
    },

    /* Работа с тестами */

    {
      path: '/admin/tests',
      name: 'Tests',
      component: Tests,
      beforeEnter: AuthService.requireAuth
    },
    {
      path: '/admin/tests/:id/edit',
      name: 'EditTest',
      component: EditTest,
      beforeEnter: AuthService.requireAuth
    },

    /* Игра */
    {
      path: '/:slug/game',
      name: 'Start',
      component: Start
    },
    {
      path: '/:slug/game/test/:id',
      name: 'TestStart',
      component: TestStart,
      beforeEnter: AuthService.requirePlayer
    },
    {
      path: '/:slug/game/test/:id/help',
      name: 'TestHelp',
      component: TestHelp
    },
    {
      path: '/:slug/game/test/quick-finish',
      name: 'FinishGame',
      component: FinishGame
    },
    {
      path: '/:slug/game/test/start',
      name: 'StartTest',
      component: StartTest
    },
    {
      path: '/:slug/auth',
      name: 'PlayerLogin',
      component: PlayerLogin
    }
  ],
  scrollBehavior (to) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash })
        }, 500)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js